@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.production-plan.admin.title' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'mes.production-plan.admin.search' | translate" #input />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<div class="table-wrapper">
	<table mat-table recycleRows [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.production-plan.admin.columns.name' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">({{ element.alias }}) {{ element.description }}</td>
		</ng-container>
		<ng-container matColumnDef="menu">
			<th mat-header-cell *matHeaderCellDef style="text-align: end"></th>
			<td mat-cell *matCellDef="let row" style="text-align: end">
				<button mat-icon-button [matMenuTriggerFor]="menu">
					<mat-icon mat-list-icon svgIcon="acies_overflow_menu" style="padding-top: 5px"></mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button mat-menu-item (click)="openTerminal(row)">
						<span>{{ 'mes.administration.terminal.shared.openbtn' | translate }}</span>
					</button>
					<button mat-menu-item (click)="openEdit(row)">
						<span>{{ 'mes.production-plan.admin.actions.edit' | translate }}</span>
					</button>
					<button mat-menu-item (click)="onDelete(row)">
						<span>{{ 'mes.production-plan.admin.actions.delete' | translate }}</span>
					</button>
				</mat-menu>
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500]" [pageSize]="1000" showFirstLastButtons></mat-paginator>
